const config = [
  { propName: 'tasks', reducerName: 'tasks' },
  { propName: 'activities', reducerName: 'activities' },
  { propName: 'interviews', reducerName: 'interviews' },
];

export const getAtsDashboardDetails = (state) => {
  const atsDashboard = {};

  config.forEach(({ propName, reducerName }) => {
    atsDashboard[propName] = state?.atsDashboardData?.[reducerName];
  });

  return atsDashboard;
};
